import { supabase } from '@/lib/supabase'

async function invokeFn(name: string, body?: any) {
  const { data, error, /* @ts-ignore */ response } = await (supabase.functions as any).invoke(name, { body })
  if (error) {
    try {
      const ctx: Response | undefined = (error as any)?.context || response
      if (ctx) {
        const ct = ctx.headers.get('content-type') || ''
        if (ct.includes('application/json')) {
          const j = await ctx.json().catch(() => null as any)
          const code = j?.error as string | undefined
          if (code) throw new Error(code)
        } else {
          const t = await ctx.text().catch(() => '')
          if (t) throw new Error(t)
        }
      }
    } catch {}
    throw new Error('Falha na Edge Function')
  }
  return (Array.isArray(data) ? (data as any)[0] : (data as any))
}

export type VipItem = {
  id: string
  email: string
  token: string
  discount_percent: number
  recurrence: 'forever' | 'repeating'
  duration_months: number | null
  plan_id: string | null
  active: boolean
  expires_at: string | null
  used_at: string | null
  user_id: string | null
  stripe_coupon_id: string | null
  created_at: string
  updated_at: string
}

export async function listVipEntitlements(): Promise<{ items: VipItem[]; links: Array<{ id: string; link: string }> }> {
  const resp = await invokeFn('admin-vip-entitlements', { action: 'list' })
  return { items: resp?.items || [], links: resp?.links || [] }
}

export async function createVipEntitlement(email: string, discount_percent: number, plan_ref?: string | null) {
  return await invokeFn('admin-vip-entitlements', { action: 'create', email, discount_percent, plan_ref: plan_ref || undefined } as any)
}

export async function updateVipEntitlement(id: string, patch: Partial<{ active: boolean; discount_percent: number; plan_ref: string | null }>) {
  return await invokeFn('admin-vip-entitlements', { action: 'update', id, ...patch } as any)
}

export async function deleteVipEntitlement(id: string) {
  return await invokeFn('admin-vip-entitlements', { action: 'delete', id } as any)
}

export async function regenerateVipToken(id: string) {
  return await invokeFn('admin-vip-entitlements', { action: 'regenerate', id } as any)
}
